var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.83,
    height: 61.663,
    viewBox: "0 0 52.83 61.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.843,24.778l6.88-7.244a10.684,10.684,0,0,0,0-14.489,9.378,9.378,0,0,0-13.744,0,10.618,10.618,0,0,0,0,14.489Z",
    transform: "translate(6.604 -0.048)",
    fill: "#efc700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.365,21.26a15.779,15.779,0,0,0-4.4.628c-2.845.612-6.732,1.472-9.3.761-3.754-1.025-6.351.265-9.1,1.654l-1.654.827a1.059,1.059,0,0,1-.893,0l-4.35-2a16.043,16.043,0,0,0-9.411-.992,23.3,23.3,0,0,1-9.924-.728h-.2A1.641,1.641,0,0,0,.01,23a26.463,26.463,0,0,0,52.827,0,1.654,1.654,0,0,0-1.472-1.737ZM26.457,46.02A23.155,23.155,0,0,1,3.4,25.081a26.645,26.645,0,0,0,9.246.314,12.983,12.983,0,0,1,7.575.711l4.35,2.018a4.449,4.449,0,0,0,3.672,0l1.8-.877c2.531-1.274,4.2-2.1,6.748-1.406,3.308.926,7.691,0,10.866-.728l1.77-.364A23.155,23.155,0,0,1,26.457,46.02Z",
    transform: "translate(-0.01 13.823)",
    fill: "#1787e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.95,26.884A1.654,1.654,0,0,0,11.3,25.23H6.334a1.654,1.654,0,0,0,0,3.308H11.3A1.654,1.654,0,0,0,12.95,26.884Z",
    transform: "translate(3.044 16.419)",
    fill: "#1787e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.654,29.968h4.962a1.654,1.654,0,1,0,0-3.308H13.654a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(7.831 17.355)",
    fill: "#1787e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.356,30.308a1.654,1.654,0,1,0,0-3.308H20.394a1.654,1.654,0,1,0,0,3.308Z",
    transform: "translate(12.238 17.577)",
    fill: "#1787e0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.716,24.9H25.754a1.654,1.654,0,0,0,0,3.308h4.962a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(15.744 16.204)",
    fill: "#1787e0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.776,29.53H8.814a1.654,1.654,0,0,0,0,3.308h4.962a1.654,1.654,0,0,0,0-3.308Z",
    transform: "translate(4.666 19.231)",
    fill: "#1787e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.616,33H13.654a1.654,1.654,0,0,0,0,3.308h4.962a1.654,1.654,0,0,0,0-3.308Z",
    transform: "translate(7.831 21.501)",
    fill: "#1787e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,29.81H15.654a1.654,1.654,0,1,0,0,3.308h4.962a1.654,1.654,0,0,0,0-3.308Z",
    transform: "translate(9.139 19.415)",
    fill: "#1787e0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.356,30.25H21.394a1.654,1.654,0,0,0,0,3.308h4.962a1.654,1.654,0,1,0,0-3.308Z",
    transform: "translate(12.892 19.702)",
    fill: "#1787e0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherServices);
export default __webpack_public_path__ + "static/media/other_services.2d918da95a631367476d2324bb183fbf.svg";
export { ForwardRef as ReactComponent };